import * as website from '$const/website';

export type SeoBuilderConfiguration = {
	title: string;
	description: string;
	canonicalUrl?: string;
	keywords?: string[];
	og?: {
		title?: string;
		description?: string;
		image?: string;
		url?: string;
	};
	twitter?: {
		title?: string;
		description?: string;
		image?: string;
		url?: string;
	};
};

export function builder(url: URL, data: SeoBuilderConfiguration): App.PageData['seo'] {
	const title = decorate(data.title);

	const og = {
		title: data.og?.title ? decorate(data.og.title) : title,
		description: data.og?.description || data.description,
		image: data.og?.image || website.image,
		url: data.og?.url || url.toString()
	};

	return {
		title,
		description: data.description,
		canonicalUrl: data.canonicalUrl || url.toString(),
		keywords: data.keywords || website.keywords,
		og,
		twitter: {
			title: data.twitter?.title ? decorate(data.twitter.title) : og.title,
			description: data.twitter?.description || og.description,
			image: data.twitter?.image || og.image,
			url: data.twitter?.url || og.url,
			card: 'summary_large_image',
			site: website.twitterHandle
		}
	};
}

function decorate(title: string): string {
	return `${title} | ${website.title}`;
}
